import type { ThemeChoice } from './theme-store';
import { useTheme } from './useTheme';

interface ThemeOption {
  id: ThemeChoice;
  label: string;
  /** Литералы, а не роли: превью показывает другую тему, чем текущая. */
  swatch: { background: string; foreground: string };
}

const OPTIONS: ThemeOption[] = [
  { id: 'light', label: 'Светлая', swatch: { background: '#F7F5EF', foreground: '#1B1F3B' } },
  { id: 'dark', label: 'Тёмная', swatch: { background: '#1B1F3B', foreground: '#F7F5EF' } },
];

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  return (
    <div role="radiogroup" aria-label="Тема" className="grid grid-cols-2 gap-3">
      {OPTIONS.map((option) => {
        const selected = option.id === theme;

        return (
          <button
            key={option.id}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => setTheme(option.id)}
            className={`flex flex-col gap-2 rounded-card border-2 bg-surface p-3 text-left ${
              selected ? 'border-accent' : 'border-border hover:border-border-strong'
            }`}
          >
            <span
              aria-hidden="true"
              className="flex h-14 items-center justify-center rounded-lg border border-border font-display text-2xl"
              style={{ backgroundColor: option.swatch.background, color: option.swatch.foreground }}
            >
              Аа
            </span>
            <span className="text-sm font-medium text-text">{option.label}</span>
            <span className="text-xs text-accent">{selected ? 'Выбрана' : ' '}</span>
          </button>
        );
      })}
    </div>
  );
}
